// components/dialogs/SharedAddressSaveWarningDialog.tsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface SharedAddressSaveWarningDialogProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export const SharedAddressSaveWarningDialog: React.FC<SharedAddressSaveWarningDialogProps> = ({
  open,
  onClose,
  onContinue,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          This change will affect all customers who are resident at this shared address.
          <WarningAmberIcon color="warning" sx={{ fontSize: "3rem", flexShrink: 0 }} />
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          If you need to update the details for an individual customer, please navigate to that customer's record and make the changes directly on their screen.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button
          variant="text"
          onClick={onContinue}
          sx={{ cursor: "pointer" }}
        >
          Continue Saving
        </Button>
        <Button
          onClick={onClose}
          color="warning"
          variant="contained"
        >
          Go Back
        </Button>
      </DialogActions>
    </Dialog>
  );
};
